type LiteratorType = any;
type AnalyticsProperties = { [key: string]: LiteratorType };

export class Literator {
  static start(accessToken: String): Promise<boolean>;
  static sendAnalytics(eventName: String, properties: AnalyticsProperties, tag?: string): Promise<boolean>;
}
